const getCookie = cookieName => {
  const cookies = document.cookie.split('; ').reduce((agg, cookie) => {
    const parts = cookie.split('=')
    agg[parts[0]] = parts[1]
    return agg
  }, {})

  return cookies[cookieName]
}

const setCookie = (cookieName, cookieValue, cookiePath = '/', cookieExpires = undefined) => {
  const inTwentyFour = new Date()
  inTwentyFour.setHours(inTwentyFour.getHours() + 24)

  const expires = (cookieExpires || inTwentyFour).toUTCString()

  document.cookie = `${cookieName}=${cookieValue}; expires=${expires}; path=${cookiePath};`
}

const unsetCookie = (cookieName, cookiePath) => {
  setCookie(cookieName, undefined, cookiePath, new Date(0))
}

export { getCookie, setCookie, unsetCookie }
